import deepFreeze from 'deep-freeze';
import serviceFactory from '@/services/serviceFactory';

export const CATALOG_STATUS = {
    NEW: 0,
    MAPPED: 1,
    FOR_MODERATION: 2,
    MODERATED: 3,
    REJECTED: 4,
};

export const ENDPOINTS = deepFreeze({
    DESCRIBED_PRODUCTS: {
        URI: () => '/api/v1/described-products',
        methods: ['get'],
        default: [],
    },
    PRODUCTS: {
        URI: () => '/api/v1/products/{{id?}}',
        methods: ['post', 'get', 'patch'],
        cacheToClear: ['/api/v1/products'],
    },
    PRODUCT_OFFERS: {
        URI: () => '/api/v1/products/{{id}}/offers',
        methods: ['get'],
        default: [],
        formatter: data => data?.items,
    },
    PRODUCT_DISTINCT_OFFERS: {
        URI: () => '/api/v1/products/{{id}}/distinct-offers',
        methods: ['get'],
    },
    PRODUCT_RE_AGGREGATE: {
        URI: () => '/api/v1/products/{{id}}/re-aggregate',
        methods: ['put'],
    },
    AGGREGATION_STATUSES: {
        URI: () => '/api/v1/aggregation-statuses',
        methods: ['get'],
        formatter: data => data?.items,
    },
    AGGREGATIONS: {
        URI: () => '/api/v1/aggregations',
        methods: ['get'],
        default: [],
    },
    CATALOG_SUGGESTION: {
        URI: () => '/api/v1/products/{{id}}/catalog-suggestion',
        methods: ['get'],
    },
    CATALOG_MAPPING: {
        URI: () => '/api/v1/products/{{id}}/catalog-mapping',
        methods: ['post'],
        cacheToClear: ['/api/v1/products'],
    },
    RISK_DIMENSIONS: {
        URI: () => '/api/v1/risk-dimensions',
        methods: ['get'],
        formatter: data => data?.items,
    },
});

export default {
    ...serviceFactory.build(ENDPOINTS),
};
